// @flow
import * as React from 'react'
import { Link } from 'react-router-dom'
import type { PacketResponse } from 'types/packet-response'

import Ui from '..'
import Icons from '../Icons'

type Props = {
  packetResponse: PacketResponse,
}

function PacketSummaryList({ packetResponse }: Props): React.Node {
  const responses = packetResponse?.responses || []

  const ResponseLink = React.useCallback(({ response, children }) => {
    return (
      <Link
        className="hover:no-underline hover:text-gray-900 w-full py-4 px-3 block"
        to={`/response/${response.id}`}
      >
        {children}
      </Link>
    )
  }, [])

  return (
    <div className="sm:mx-6 mb-4 border rounded overflow-hidden flex-1 h-full">
      <table className="table-auto min-w-full bg-white">
        <thead>
          <tr className="border-b border-gray-200 bg-gray-50">
            <Ui.TableTitle />
            <Ui.TableTitle>Form name</Ui.TableTitle>
          </tr>
        </thead>
        <tbody>
          {responses.sort().map((response, index) => (
            <tr className="cursor-pointer hover:bg-gray-100" key={response.id}>
              <Ui.TableItem paddingHorizontal={0} paddingVertical={0}>
                <ResponseLink response={response}>
                  {response.is_submitted ||
                  (packetResponse.form_index &&
                    packetResponse?.form_index > index) ? (
                    <Icons.ClipboardCheck
                      className="ml-3"
                      color="text-green-500"
                    />
                  ) : response.has_visited ? (
                    <Icons.ClipboardList
                      className="ml-3"
                      color="text-yellow-500"
                    />
                  ) : (
                    <Icons.ClipboardList
                      className="ml-3"
                      color="text-gray-300"
                    />
                  )}
                </ResponseLink>
              </Ui.TableItem>
              <Ui.TableItem
                paddingHorizontal={0}
                paddingVertical={0}
                style={{ maxWidth: '90vw' }}
              >
                <ResponseLink response={response}>
                  {response?.name}
                </ResponseLink>
              </Ui.TableItem>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default PacketSummaryList
